const common = {
  borderThickness: '1px',
  defaultWidth: '200px',
  height: '36px',
  lineHeight: '24px',
  tooltipWidth: '400px'
}

export const web = {
  ...common
}

export const tablet = {
  ...common,
  borderThickness: '2px',
  defaultWidth: '256px',
  height: '64px',
  lineHeight: '32px',
  tooltipWidth: '320px'
}
